// extracted by mini-css-extract-plugin
export default {"ctn":"commonLayout_ctn__2j84n","textBox":"commonLayout_textBox__eA0rW"};